const LangGermanyFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="3.66" fill="#000000" />
    <rect width="16" height="3.66" y="3.66" fill="#D00F24" />
    <rect width="16" height="3.66" y="7.32" fill="#FFCC00" />
  </svg>
);

export default LangGermanyFlag;
